import { parseRateStackResponse, RateStackResponse, Role } from "@eave/shared/types/api";

import APIClient from "web_modules/APIClient";
import { getSessionToken, tokenHasRoles } from "web_modules/shared/session";

const getRolePrefix = (): string => {
  if (tokenHasRoles(getSessionToken(), Role.Underwriter)) {
    return "uw";
  }
  if (tokenHasRoles(getSessionToken(), Role.CapitalMarkets)) {
    return "cm";
  }
  return "lo";
};

export const getRateStack = async (appId: number): Promise<RateStackResponse> => {
  return APIClient.get(`/${getRolePrefix()}/loan_applications/${appId}/points_and_credits`).then(
    (resp: any) => {
      return parseRateStackResponse(resp.rates);
    },
  );
};

export const setPriceDelta = async (appId: number, delta: number): Promise<void> => {
  return APIClient.post(`/lo/loan_applications/${appId}/points_and_credits`, {
    price_delta: delta,
  });
};
